import {
  MDBBtn,
  MDBIcon,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import PopupLoader from "../../../views/popups/PopupLoader";
import AddSpeedDials from "../../../views/popups/users/AddSpeeddials";
import DelUsrStreamsSpeedDial from "../../../views/popups/users/DelUsrStreamsSpeedDial";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import { Tooltip } from "react-tooltip";
import { formattedNumber } from "../../../views/popups/phonenumbers/AddRemoveNumbers";
import { getStreamsProductName } from "../../../apiclients/CommonUtils";

function UserStreamsSpeedDial({ speedDialList, setSuccessMessage, useragent ,isstreamsReq}) {
  const { t, i18n } = useTranslation();
  const [addSpeedDial, setAddSpeedDial] = useState(false);
  const togglePopup = () => setAddSpeedDial(!addSpeedDial);
  const [editSpeedObj, setEditSpeedObj] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [modifiedObj, setModifiedObj] = useState({});
  const [speedDials, setSpeedDials] = useState([]);
  const [speedlist, setspeedList] = useState(true);
  const [isdeleteNumber, setIsDeleteNumbers] = useState(false);
  const dtogglePopup = () => setIsDeleteNumbers(!isdeleteNumber);
  const [speedNo, setSpeedNo] = useState(0);
  const [deleteFlag, setDeleteFlag] = useState(false);
  const addSpeedDialsRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);

  const streamsProductName = getStreamsProductName();


  function handleClick() {
    addSpeedDialsRef.current.click();
  }

  const handleDelete = (e, speedNo) => {
    e.preventDefault();
    e.stopPropagation();
    setSpeedNo(speedNo);
    dtogglePopup();
  };

  const editSpeedDial = (e, speedObj) => {
    e.preventDefault();
    e.stopPropagation();
    setEditSpeedObj(speedObj);
    setIsEdit(true);
    togglePopup();
  };

  useEffect(() => {
    if (deleteFlag) {
      const removespeed = speedDials.filter(
        (item) => parseInt(item.speed_dial_number) !== parseInt(speedNo)
      );
      setSpeedDials(removespeed);
      setDeleteFlag(false);
    }
  }, [deleteFlag]);

  useEffect(() => {
    if (Object.keys(modifiedObj).length > 0) {
      if (isEdit) {
        const indexmatch = speedDials.findIndex(
          (Obj) => Obj.speed_dial_id === modifiedObj.speed_dial_id
        );
        if (indexmatch !== -1) {
          speedDials.splice(indexmatch, 1, modifiedObj);
        }
        setIsEdit(false);
      } else {
        const indexmatch = speedDials.findIndex(
          (Obj) => Obj.speed_dial_number === modifiedObj.speed_dial_number
        );
        if (indexmatch !== -1) {
          speedDials.splice(indexmatch, 1, modifiedObj);
        } else {
          setSpeedDials((prev) => [...prev, modifiedObj]);
        }
      }
    }
  }, [modifiedObj]);

  useEffect(() => {
    if (speedDialList.length > 0 && speedlist) {
      setSpeedDials(speedDialList);
      setspeedList(false);
    }
  }, [speedDialList, speedlist]);

  return (
    <>
      <div className="add-numbermain">
        <div>
          <div className="general-settings" id="SpeedDials">
            {t("SpeedDials")}
          </div>
          <span className="phrecording">{t("SpeedDialstxt", { "PRODUCT_NAME": streamsProductName })}</span>
        </div>
        {!isstreamsReq && (
        <MDBBtn
          className="m-2"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setEditSpeedObj({});
            setIsEdit(false);
            togglePopup();
          }}
        >
          <MDBIcon fas icon="plus" size="sm" /> Add Speed Dial
        </MDBBtn>
                   )}
      </div>
      <div>
      <div
               {...(isstreamsReq
                ? {
                    title:
                        "User does not have permission to edit",
                    className: "disabled-form cursor-notAllowed",
                    onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    },
                }
                : {})}
              >
        <MDBTable className="mt-2">
          <MDBTableHead>
            <tr>
              <th scope="col" className="w-30">
                {t("SpeedDialNumbe")}
              </th>
              <th scope="col" className="w-30">
                {t("name")}
              </th>
              <th scope="col" className="w-60">
                {t("Number")}
              </th>
              <th scope="col" className="w-10 text-center">
                {t("Remove")}
              </th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {speedDials &&
              speedDials.length > 0 &&
              speedDials.map((speed) => (
                <>
                  <tr onClick={(e) => editSpeedDial(e, speed)}>
                    <td scope="row">{speed.speed_dial_number}</td>
                    <td>{speed.name}</td>
                    <td>{formattedNumber(speed.ph_number)}</td>
                    <td className="text-center">

                      <div className="d-flex align-items-center ms-2">
                        <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) =>
                          handleDelete(e, speed.speed_dial_number)
                        }>
                          <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
                        </div>
                      </div>
                      {/* <i
                        className="fas fa-xmark"
                        onClick={(e) =>
                          handleDelete(e, speed.speed_dial_number)
                        }
                      ></i> */}
                    </td>
                  </tr>
                </>
              ))}
          </MDBTableBody>
        </MDBTable>
        </div>
      </div>
      {addSpeedDial && (
        <PopupLoaderNew
          title={isEdit ? "Edit Speed Dial" : "Add Speed Dial"}
          content={
            <AddSpeedDials
              setSuccessMessage={setSuccessMessage}
              editSpeedObj={editSpeedObj}
              useragent={useragent}
              modifiedObj={setModifiedObj}
              onClose={togglePopup}
              ref={addSpeedDialsRef}
              setIsloading={setisLoading}
            />
          }
          onShow={setAddSpeedDial}
          onClose={togglePopup}
          onSave={handleClick}
          isloading={isLoading}
          flag={isEdit ? 2 : 1}
        />
      )}
      {isdeleteNumber && (
        <PopupLoaderNew
          title={"Remove Speed Dial"}
          content={
            <DelUsrStreamsSpeedDial
              useragent={useragent}
              speedNo={speedNo}
              setDeleteFlag={setDeleteFlag}
              onClose={dtogglePopup}
              setSuccessMessage={setSuccessMessage}
              ref={addSpeedDialsRef}
              setIsloading={setisLoading}
            />
          }
          onShow={setIsDeleteNumbers}
          onClose={dtogglePopup}
          onSave={handleClick}
          isloading={isLoading}
          flag={4}
        />
      )}

      <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
        Remove
      </Tooltip>
    </>
  );
}

export default UserStreamsSpeedDial;
